import { SupabaseClient } from "@supabase/auth-helpers-react";

export type CollectableHolding = {
    id: number;
    ticketAddress: string;
    tokenId: number;
    ownershipValid: number;
    isLocked: boolean;
    isFeatured?: boolean;
    price?: number;
    creator?: string;
    //name: string;
   // description:string;
    //imageUrl:string;

};

export type CollectableHoldingState = {
    ownedTickets: Map<number, CollectableHolding>;
    loading: boolean; 
    error: CollectableHoldingError;
}

export enum CollectableHoldingError {
    NONE,
    LOADING_FAILED
}

export type FetchHoldingsByUserIdParams = {
    supabase: SupabaseClient<any, "public", any>;
    userId: string;
}

export type FetchHoldingByCollectableHoldingIdParams = {
    supabase: SupabaseClient<any, "public", any>;
    collectableHoldingId: number;
}

export type FetchUserWalletAddressParams = {
    userId: string;
}
